var SecureTeamTips = {
  render: function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('div', {
      staticClass: "secure-team-dialog"
    }, [_vm.isTeamCreator ? _c('div', [_c('p', {
      staticClass: "secure-team-dialog-tips"
    }, [_vm._v("所选文件(夹)包含加密文件，请选择" + _vm._s(_vm.text) + "到团队外是否解密")]), _vm._v(" "), _c('div', {
      "class": ['secure-item', 'first', {
        'active': _vm.decrypt
      }],
      on: {
        "click": function click($event) {
          _vm.decrypt = true;
        }
      }
    }, [_c('b'), _vm._v(" "), _c('p', {
      staticClass: "secure-team-dialog-tips"
    }, [_vm._v("解密")]), _vm._v(" "), _c('el-popover', {
      attrs: {
        "placement": "bottom",
        "title": "",
        "trigger": "hover",
        "popperClass": "secure-team-tips-popover",
        "content": "仅有另存权限的加密文件可被解密"
      }
    }, [_c('KIcon', {
      staticClass: "question",
      attrs: {
        "slot": "reference",
        "type": "question"
      },
      slot: "reference"
    })], 1), _vm._v(" "), _c('p', {
      staticClass: "selected-warning-tips"
    }, [_vm._v("解密后的文件可被分享给任何人查看，请谨慎操作")])], 1), _vm._v(" "), _c('div', {
      "class": ['secure-item', {
        'active': !_vm.decrypt
      }],
      on: {
        "click": function click($event) {
          _vm.decrypt = false;
        }
      }
    }, [_c('b'), _vm._v(" "), _c('p', {
      staticClass: "secure-team-dialog-tips"
    }, [_vm._v("不解密")]), _vm._v(" "), _c('p', {
      staticClass: "unselect-warning-tips"
    }, [_vm._v("保留文件原有的权限")])])]) : _c('div', [_c('p', {
      staticClass: "secure-team-dialog-tips"
    }, [_vm._v("所选文件(夹)若包含加密文件，" + _vm._s(_vm.text) + "到团队外其他人可能打不开，请确认是否" + _vm._s(_vm.text))])]), _vm._v(" "), _c('div', {
      staticClass: "footer"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.submit
      }
    }, [_vm._v(_vm._s(_vm.btnText))]), _vm._v(" "), _c('el-button', {
      on: {
        "click": _vm.cancel
      }
    }, [_vm._v("取消")])], 1)]);
  },
  staticRenderFns: [],
  name: 'KSecureTeamTips',
  componentName: 'KSecureTeamTips',
  props: {
    onSecureCallback: {
      type: Function,
      "default": function _default() {}
    },
    isTeamCreator: {
      type: Boolean,
      "default": true
    },
    actionType: {
      type: String,
      "default": 'copy'
    }
  },
  data: function data() {
    return {
      decrypt: false,
      btnText: '确定',
      text: ''
    };
  },
  created: function created() {
    this.btnText = {
      copy: this.isTeamCreator ? '粘贴' : '复制',
      move: '移动'
    }[this.actionType];
    this.text = {
      copy: '复制',
      move: '移动'
    }[this.actionType];
    this.$emit('propsChange', {
      title: this.isTeamCreator ? '解密文件' : "".concat(this.text, "\u6587\u4EF6")
    });
  },
  methods: {
    cancel: function cancel() {
      this.$emit('close');
    },
    submit: function submit() {
      this.cancel();
      this.onSecureCallback(this.decrypt);
      this.cancel();
    }
  }
};

SecureTeamTips.install = function (Vue) {
  Vue.component(SecureTeamTips.name, SecureTeamTips);
};

export { SecureTeamTips as default };
